/*
  DSXCIAL — Guia de tallas en ventana emergente
  ---------------------------------------------------------------
  El enlace GUIA DE TALLAS de la pagina de producto apunta a
  /pages/tabla-de-tallas-<prenda> y abria otra pestana: sacaba a la
  gente del producto justo cuando estaba eligiendo talla.

  Este archivo no cambia el enlace, lo intercepta. Al hacer clic trae
  el contenido de esa misma pagina y lo muestra encima del producto en
  una ventana. Si el navegador es viejo o la peticion falla, el enlace
  sigue funcionando como siempre: nunca se queda sin salida.

  Se engancha por la URL y no por la clase del bloque, igual que las
  secciones 3 y 5 de custom.css: la clase lleva el id del bloque y
  cambiaria si lo vuelves a crear en el editor de temas. Asi cubre las
  guias de las cuatro plantillas de producto y cualquiera que agregues
  despues con esa misma ruta, sin tocar los JSON de plantilla.

  Se pide la pagina completa y se recorta #MainContent. Se probo antes
  la API de renderizado de secciones (?section_id=main), que traeria
  solo unos kilobytes en vez de la pagina entera, pero las tres paginas
  de tallas tienen guardada la plantilla "page" (o sea page.page, que
  no existe en el tema y Shopify resuelve sola al dibujar), asi que esa
  ruta contesta 404. La peticion completa es inmune a eso y a cualquier
  plantilla que se les ponga despues.

  Para que el peso no se note, la tabla se pide en cuanto el cursor
  roza el enlace y se guarda en memoria: al hacer clic ya esta.

  Los estilos viven en assets/custom-guia-tallas.css.
*/

(function () {
  'use strict';

  var SELECTOR_ENLACE = "a[href*='/pages/tabla-de-tallas']";

  var soportado =
    typeof window.fetch === 'function' &&
    typeof window.HTMLDialogElement === 'function' &&
    typeof window.HTMLDialogElement.prototype.showModal === 'function';

  if (!soportado || window.dsxGuiaTallas) return;
  window.dsxGuiaTallas = true;

  var cache = {};
  var dialogo = null;
  var refTitulo = null;
  var refCuerpo = null;
  var refCerrar = null;
  var disparador = null;
  var scrollPrevio = '';

  function enlaceDe(evento) {
    var destino = evento.target;
    return destino && destino.closest ? destino.closest(SELECTOR_ENLACE) : null;
  }

  function clicSimple(evento) {
    return (
      !evento.defaultPrevented &&
      evento.button === 0 &&
      !evento.metaKey &&
      !evento.ctrlKey &&
      !evento.shiftKey &&
      !evento.altKey
    );
  }

  function construir() {
    if (dialogo) return;

    dialogo = document.createElement('dialog');
    dialogo.className = 'dsx-guia';
    dialogo.setAttribute('aria-labelledby', 'dsx-guia-titulo');
    dialogo.innerHTML = [
      '<div class=dsx-guia__cabecera>',
      '<h2 class=dsx-guia__titulo id=dsx-guia-titulo></h2>',
      '<button type=button class=dsx-guia__cerrar aria-label=Cerrar>',
      '<svg viewBox=\'0 0 20 20\' aria-hidden=true focusable=false>',
      '<path d=\'M5 5 L15 15 M15 5 L5 15\'></path>',
      '</svg>',
      '</button>',
      '</div>',
      '<div class=dsx-guia__cuerpo></div>'
    ].join('');

    refTitulo = dialogo.querySelector('.dsx-guia__titulo');
    refCuerpo = dialogo.querySelector('.dsx-guia__cuerpo');
    refCerrar = dialogo.querySelector('.dsx-guia__cerrar');

    refCerrar.addEventListener('click', cerrar);

    // El <dialog> ocupa toda la pantalla, asi que un clic en el fondo
    // oscuro llega al dialogo mismo y no a la caja blanca.
    dialogo.addEventListener('click', function (evento) {
      if (evento.target === dialogo) cerrar();
    });

    // Cubre tambien el cierre con Escape, que hace el navegador solo.
    dialogo.addEventListener('close', restaurar);

    document.body.appendChild(dialogo);
  }

  function cerrar() {
    if (dialogo && dialogo.open) dialogo.close();
  }

  function restaurar() {
    document.documentElement.style.overflow = scrollPrevio;
    if (disparador && document.contains(disparador)) disparador.focus();
    disparador = null;
  }

  function limpiar(nodo) {
    var basura = nodo.querySelectorAll('script, style, link, noscript');
    for (var i = 0; i < basura.length; i++) basura[i].parentNode.removeChild(basura[i]);

    // La pagina abre con un titulo TABLA DE TALLAS que dentro de la
    // ventana repetiria el rotulo de la cabecera.
    var primero = nodo.querySelector('h1, h2, h3, h4, h5, h6');
    if (primero && /tabla\s+de\s+tallas/i.test(primero.textContent)) {
      primero.parentNode.removeChild(primero);
    }

    return nodo.innerHTML;
  }

  function extraer(html, selectores) {
    var doc = new DOMParser().parseFromString(html, 'text/html');

    for (var i = 0; i < selectores.length; i++) {
      var nodo = doc.querySelector(selectores[i]);
      if (nodo && nodo.textContent.trim() !== '') return limpiar(nodo);
    }

    return '';
  }

  function pedir(href) {
    if (cache[href]) return cache[href];

    var promesa = fetch(href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (respuesta) {
        if (!respuesta.ok) throw new Error('HTTP ' + respuesta.status);
        return respuesta.text();
      })
      .then(function (html) {
        var contenido = extraer(html, [
          '#MainContent rte-formatter',
          '#MainContent .rte',
          '#MainContent .section-content-wrapper',
          '#MainContent'
        ]);

        if (!contenido) throw new Error('sin contenido');
        return contenido;
      });

    cache[href] = promesa;
    promesa['catch'](function () {
      delete cache[href];
    });

    return promesa;
  }

  function abrir(enlace) {
    construir();

    var href = enlace.href;
    var rotulo = (enlace.textContent || '').trim() || 'Guia de tallas';

    disparador = enlace;
    refTitulo.textContent = rotulo;
    refCuerpo.innerHTML = '<p class=dsx-guia__aviso>Cargando...</p>';
    refCuerpo.scrollTop = 0;

    scrollPrevio = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';

    dialogo.showModal();
    refCerrar.focus();

    pedir(href).then(
      function (contenido) {
        if (!dialogo.open) return;
        refCuerpo.innerHTML = '<div class=rte>' + contenido + '</div>';
        refCuerpo.scrollTop = 0;
      },
      function () {
        // Antes una ventana vacia, la pagina de siempre.
        cerrar();
        window.location.href = href;
      }
    );
  }

  function adelantar(evento) {
    var enlace = enlaceDe(evento);
    if (!enlace) return;

    enlace.setAttribute('aria-haspopup', 'dialog');
    pedir(enlace.href)['catch'](function () {});
  }

  document.addEventListener('click', function (evento) {
    var enlace = enlaceDe(evento);
    if (!enlace || !clicSimple(evento)) return;

    evento.preventDefault();
    abrir(enlace);
  });

  document.addEventListener('pointerover', adelantar);
  document.addEventListener('focusin', adelantar);

  function marcar() {
    var enlaces = document.querySelectorAll(SELECTOR_ENLACE);
    for (var i = 0; i < enlaces.length; i++) {
      enlaces[i].setAttribute('aria-haspopup', 'dialog');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', marcar);
  } else {
    marcar();
  }
})();
